import React, { useState, useEffect, useCallback } from "react";
import {
  Col,
  Row,
  Breadcrumb,
  Space,
  message,
} from "antd";

import "react-vis/dist/style.css";
import DragUpload from "../Form/DragUpload";

const uploadBulkPOD = (res) => {
  try {
    message.info(`Please check your email after few minutes`)
  } catch (error){
    message.error(error.response.data.message || error.message);
  }
};

const POD = () => {
  return (
    <Space direction="vertical" style={{ display: "flex" }}>
      <div className="header">
        <Row>
          <Col span={12}>
            <h2 className="detail-header-text">POD</h2>
          </Col>
          <Col span={12}>
            <Breadcrumb style={{ margin: "10px 0", textAlign: "right" }} />
          </Col>
        </Row>
      </div>

      <DragUpload
        action={`${process.env.REACT_APP_SERVER_URL}/api/orders/pod`}
        accept=".xls, .xlsx"
        method="post"
        onUploadSuccess={(res) => uploadBulkPOD(res)}
        additionalDesc={`Upload Excel file with "Tracking Number" header and list of Tracking Number`}
      />
    </Space>
  );
};

export default POD;
